import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';

/**
 * 공지사항, FAQ 컴포넌트
 * @returns JSX.Element
 */
const CommunicationBanner = () => {
	return (
		<section className="main-cs main-section">
			<div className="main-cs-inner">
				<div className="title-group align-center">
					<p className="title">스텔라의 이야기를 들어보세요!</p>
				</div>
				<div className="main-board-group">
					<div className="main-board-wrap">
						<div className="main-board-title">
							공지 사항 <Link to={NAV_PATH.CUSTOMER_SUPPORT.NOTICE}>더보기</Link>
						</div>
						<ul className="main-board-list notice" data-template={`<li><a href="#" class="title"></a></li>`}></ul>
					</div>
					<div className="main-board-wrap">
						<div className="main-board-title">
							자주 묻는 질문 <Link to={NAV_PATH.CUSTOMER_SUPPORT.FAQ}>더보기</Link>
						</div>
						<ul className="main-board-list faq" data-template={`<li><a href="#" class="title"></a></li>`}></ul>
					</div>
				</div>
			</div>
		</section>
	);
};

export default CommunicationBanner;
